import React from 'react';
import { testId } from '../../../../utils/testIds';
import { RENDER_MODE } from '../../constants';

function EmailField({ config, value, onChange, onBlur, disabled, required, error, renderMode }) {
  const displayValue = value ?? '';

  if (renderMode === RENDER_MODE.CARD || renderMode === RENDER_MODE.GRID) {
    return (
      <span className="field-engine-email-value">
        {displayValue
          ? <a href={`mailto:${displayValue}`}>{displayValue}</a>
          : <span className="field-engine-empty">—</span>}
      </span>
    );
  }

  return (
    <input
      id={config.fieldKey}
      data-test={testId('field', config.fieldKey, 'input')}
      name={config.fieldKey}
      type="email"
      className={`field-engine-input field-engine-input--email${error ? ' field-engine-input--error' : ''}${disabled ? ' disabled' : ''}`}
      value={displayValue}
      onChange={e => {
        const next = e.target.value;
        onChange(config.maxLength ? next.slice(0, config.maxLength) : next);
      }}
      onBlur={onBlur}
      disabled={disabled}
      required={required}
      aria-required={required}
      aria-invalid={!!error}
      autoComplete="email"
      placeholder={config.fieldSettings?.placeholder ?? config.label ?? ''}
      maxLength={config.maxLength || undefined}
    />
  );
}

export default EmailField;
